import { useAddressSliceActions } from './useAddressSliceActions'
import { AddressSliceKey } from './useAddressState'

// чистит ошибку адреса
export const useClearErrorsAddress = (
  addressKey: AddressSliceKey = 'default',
) => {
  const { setErrorMessage, setIsError } = useAddressSliceActions(addressKey)

  return () => {
    setIsError(false)
    setErrorMessage('')
  }
}
